import * as React from "react"
import { Typography } from '@mui/material'


export default function sectionColumn() {
    return {
		name: 'section',
		label: 'Section',
		options: {
			customBodyRowRenderLite: value => <Typography variant='subtitle2'>
				{value || '-'}
			</Typography>
		}
	}
}